export const CURRENCY_TYPES = {
  SET_CURRENCY_BEGIN: 'SET_CURRENCY_BEGIN',
  SET_CURRENCY_ERROR: 'SET_CURRENCY_ERROR',
  SET_CURRENCY_SUCCESS: 'SET_CURRENCY_SUCCESS',
};
